<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center control-section">
					<offer-request />
					<panel :title="$t('eny.we_re_sorry')" addclass="mt-4">
						<div class="lg:px-40 pt-7 grid justify-items-center">
							<div class="text-xl mb-3">{{$t('eny.sorry_thanks_msg')}}</div>
							<div v-for="(line, nr) in sorry_reason_msg" :key="nr" class="text-left w-full" :class="line.length==0 ? 'pt-2' : ''">{{line}}</div>
						</div>
					</panel>
					<!-- Buttons -->
					<div class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-6">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="end">{{$t('eny.end')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Panel from "../../Base/Panel.vue";
import OfferRequest from "./Request.vue";

export default {
	name: "CustomerRejection",
	components: {
		'panel': Panel,
		'offer-request': OfferRequest,
	},
	data() {
		return {
			sorry_reason_msg: JSON.parse(this.$t('eny.sorry_reason_msg')),
		};
	},
	mounted() {
		this.$store.dispatch('customer/update_offer_step', 4);
	},
	methods: {
		end() {
			// this.$store.dispatch('customer/store_status', 3);
			this.$store.dispatch('customer/reset');
			this.$router.push('/offer');
		},
	},
}
</script>
